export const LINKS = [
    { path: '/dashboard', title: 'Dashboard', icon: 'dashboard', showMenu: true},
    { path: './licitacao', title: 'Nova Licitação', icon: 'archive', showMenu: true},
    { path: './licitacao/list', title: 'Licitações', icon: 'archive', showMenu: true },
    { path: './licitacao/edit/:id', title: 'Editar Licitação', icon: 'archive', showMenu: false }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/links.ts